"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROOMMATE_INVITATION_FIELDS = void 0;
var entities_1 = require("@common/entities");
exports.ROOMMATE_INVITATION_FIELDS = [
    {
        name: 'name',
        label: 'Name',
        type: entities_1.FieldType.Text,
        customType: entities_1.FieldType.Text,
        sequence: 1,
        required: false,
        enabled: true,
        nonRemovable: true,
    },
    {
        name: 'email',
        label: 'Email',
        type: entities_1.FieldType.Email,
        customType: entities_1.FieldType.Email,
        sequence: 2,
        required: false,
        enabled: true,
        nonRemovable: true,
    },
    {
        name: 'invitation_sent',
        label: 'Invitation Sent',
        type: entities_1.FieldType.Text,
        customType: entities_1.FieldType.Text,
        sequence: 3,
        required: false,
        enabled: true,
        nonRemovable: true,
    },
    {
        name: 'status',
        label: 'Status',
        type: entities_1.FieldType.Text,
        customType: entities_1.FieldType.Text,
        sequence: 4,
        required: false,
        enabled: true,
        nonRemovable: true,
    },
];
